import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import Card from '../../../Card/Card';
import { shouldRenderWaypoint, renderChildren, parsePropsToDisplay } from '../../../../helpers';
import { checkIfShouldRenderGtm } from '../helpers';
import Banner from '../../../Banner';
const CardsRenderItem = ({
  cardProps,
  listProps,
  bannerProps,
  index,
  currentListLength,
  cardChildren,
  gtmChildren,
  modifier,
  gridModifier,
  propsToDisplayModifiers,
  propsToDisplay,
  shouldRenderBanner,
  bannerIndex,
  priority,
  enableOverlay,
  autoScrollTimer,
  arrowSize,
  overlayModifier,
  titleOverlayModifier,
  graphqlEntityMap
}) => {
  const {
    initialOffset,
    isInfinite,
    style,
    name,
    id,
    triggerInfiniteScroll,
    displayCount,
    displayCategory = true,
    displayThumbnail = true,
    displayTitle = true,
    listTotal,
    itemsPerPage
  } = listProps;
  const currentItemIndex = initialOffset + index;
  const renderWaypoint = isInfinite && shouldRenderWaypoint(index, currentListLength, currentItemIndex, listTotal);
  const shouldRenderGtm = gtmChildren && checkIfShouldRenderGtm(itemsPerPage, currentListLength, index);
  const parsedPropsToDisplay = parsePropsToDisplay(cardProps, propsToDisplay);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGtm && renderChildren(gtmChildren), displayCount && /*#__PURE__*/React.createElement("div", {
    className: "heading heading--section heading--section--count"
  }, /*#__PURE__*/React.createElement("span", {
    className: "section-number"
  }, currentItemIndex + 1), /*#__PURE__*/React.createElement("span", {
    className: "section-total"
  }, "/", listTotal)), /*#__PURE__*/React.createElement("div", {
    className: "list__item list__item--compact"
  }, renderWaypoint && /*#__PURE__*/React.createElement(Waypoint, {
    onEnter: triggerInfiniteScroll
  }), /*#__PURE__*/React.createElement(Card, _extends({
    id: id,
    graphqlEntityMap: graphqlEntityMap,
    gridModifier: gridModifier,
    propsToDisplay: propsToDisplay,
    parsedPropsToDisplay: parsedPropsToDisplay,
    propsToDisplayModifiers: propsToDisplayModifiers,
    modifier: modifier,
    style: style,
    cardChildren: cardChildren,
    displayCategory: displayCategory,
    displayThumbnail: displayThumbnail,
    displayTitle: displayTitle,
    cardProps: cardProps,
    gtmId: name,
    gtmChildren: gtmChildren,
    priority: priority,
    arrowSize: arrowSize,
    enableOverlay: enableOverlay,
    overlayModifier: overlayModifier,
    titleOverlayModifier: titleOverlayModifier
  }, cardProps))), shouldRenderBanner && /*#__PURE__*/React.createElement(Banner, _extends({}, bannerProps, {
    renderCounter: bannerIndex
  })));
};
CardsRenderItem.propTypes = {
  cardProps: PropTypes.object.isRequired,
  listProps: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  currentListLength: PropTypes.number.isRequired,
  propsToDisplayModifiers: PropTypes.array.isRequired,
  shouldRenderBanner: PropTypes.bool.isRequired,
  bannerIndex: PropTypes.number.isRequired,
  bannerProps: PropTypes.object,
  gridModifier: PropTypes.string,
  propsToDisplay: PropTypes.array,
  graphqlEntityMap: PropTypes.object.isRequired,
  modifier: PropTypes.string,
  cardChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  gtmChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  priority: PropTypes.bool,
  enableOverlay: PropTypes.bool,
  overlayModifier: PropTypes.string,
  titleOverlayModifier: PropTypes.string,
  autoScrollTimer: PropTypes.number,
  arrowSize: PropTypes.string
};
CardsRenderItem.defaultProps = {
  priority: false,
  bannerProps: null,
  gridModifier: '',
  propsToDisplay: [],
  modifier: '',
  cardChildren: [],
  gtmChildren: [],
  enableOverlay: false,
  autoScrollTimer: 0,
  overlayModifier: '',
  titleOverlayModifier: '',
  arrowSize: ''
};
export default CardsRenderItem;
//# sourceMappingURL=CardsRenderItem.js.map